import * as React from "react";
import { View, Text, Image, Dimensions } from "react-native";
import { ids, styles } from "./FeatureTripCardCss.js";
import { Surface, TouchableRipple } from "react-native-paper";
import tripCardImg from "../../../../assets/DefaultImages/defaultTrip.jpeg";
import { useNavigation } from "@react-navigation/native";
import moment from "moment";
import { blackColor, subTextColor } from "../../../constant/constantCss.js";
import MarqueeText from "react-native-marquee";

const FeaturedTripCard = ({
  id,
  title,
  address,
  is_public,
  amount,
  image,
  departure_date,
  no_of_days,
}) => {
  const { width } = Dimensions.get("screen");
  const navigation = useNavigation();
  const handleButtonClick = () => {
    navigation.navigate("ShowTripInfo", { data: id });
  };
  return (
    <TouchableRipple
      onPress={handleButtonClick}
      style={[styles.upcomingCardContainer]}
      dataSet={{ media: ids.upcomingCardContainer }}
    >
      <Surface
        elevation={1}
        style={styles.surfaceContainer}
        dataSet={{ media: ids.surfaceContainer }}
      >
        <Image
          resizeMode={width <= 1030 ? "cover" : "stretch"}
          style={styles.cardImage}
          source={image ? { uri: image } : tripCardImg}
        />
        <View style={styles.cardFooter}>
          <View style={styles.cardleftFooter}>
            <View style={styles.textFlex}>
              <MarqueeText
                style={styles.cardPrimaryText}
                speed={0.2}
                marqueeOnStart={true}
                loop={true}
                delay={1000}
              >
                {title}
              </MarqueeText>
              <Text style={styles.cardSecondaryText}>
                &#8377; {`${amount}/- `}
                <Text
                  style={{
                    fontSize: 14,
                    color: subTextColor,
                    fontWeight: "100",
                  }}
                >
                  Per Person
                </Text>
              </Text>

              <Text style={styles.chipText}>
                {` ${no_of_days ?? 0} Day${no_of_days > 1 ? "s" : ""}`}

                {no_of_days - 1 > 0 &&
                  ` / ${no_of_days - 1 ?? 0} Night${
                    no_of_days - 1 > 1 ? "s" : ""
                  }`}
                {!is_public && (
                  <Text style={[styles.privateTripText]}> | Private </Text>
                )}
              </Text>
              <MarqueeText
                style={{ fontSize: 16, color: blackColor }}
                speed={0.2}
                marqueeOnStart={true}
                loop={true}
                delay={1000}
              >
                <Text style={styles.chipText}>Departure Date : </Text>
                {departure_date?.map((res, index) => (
                  <Text key={index}>
                    {moment(res).format("Do MMM YYYY")}
                    {index == departure_date.length - 1 ? "" : ", "}
                  </Text>
                ))}
              </MarqueeText>
            </View>
          </View>
        </View>
      </Surface>
    </TouchableRipple>
  );
};

export default FeaturedTripCard;
